import styled from 'styled-components';
import Avatar, { AVATAR_TYPE } from '../Avatar';
import { useEffect, useState } from 'react';
import theme from '../../shared/theme';
import LocationOn from '@material-ui/icons/LocationOn';
import {
  StyledButtonOutlined,
  StyledButtonFilled,
  StyledButtonDisabled,
} from '../Button';
import { useHistory } from 'react-router';
import getInstance from '../../request';
import { getDisplayValue } from '../../views/UserProfile/index.util';
import { Tooltip } from 'antd';
import { createClient } from '../../shared/graphql';
import { CRIMSON_APP_API_URI } from '../../utils/settings';
import { QUERY_USER_INFO } from '../../graphql';
const CR_Client = createClient({
  endpoint: CRIMSON_APP_API_URI,
});

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: white;
  border: 1px solid #e3e7ed;
  position: relative;
  border-radius: 8px;
  & .header-bg {
    width: 100%;
    border-radius: 8px 8px 0 0;
  }
  padding-bottom: 32px;
`;
const HobbiesSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 27px;
  margin-top: 16px;
  .title {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.6px;
    color: #a9acc0;
    margin-bottom: 8px;
  }
  .hobbies {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.7px;
    color: #1d1e2b;
    max-width: 260px;
  }
`;

const AvatarContainer = styled.div`
  margin: 0 auto;
  position: absolute;
  bottom: 0px;
  transform: translateY(50%);
  & .default-avatar-container {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: transparent;
    border: 8px solid rgb(255 255 255 / 80%);
    box-shadow: 0px 8px 28px 0px rgb(185 185 185 / 25%);
    /* &:hover {
      cursor: pointer;
      transform: rotate(666turn);
      transition: all 59s cubic-bezier(.34,0,.84,1) 1s;
    } */
  }
`;

const ApplicationYear = styled.div`
  font-family: 'Lato';
  font-style: italic;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #a9acc0;
  padding: 2px 8px;
  position: absolute;
  bottom: -8px;
  transform: translateY(100%);
  right: 15px;
  background: #f3f6fa;
  border-radius: 20px;
`;

const NameSection = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #1d1e2b;
  margin-top: 50px;
  max-width: 250px;
  margin: 50px auto 0px auto;
`;

const ShortBio = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #73747d;
  width: calc(100% - 92px);
  margin: 21px auto 0px auto;
  max-width: 252px;
`;

const LocationSection = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #a9abc0;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Role = styled.div`
  padding: 4px 12px;
  font-family: 'Lato';
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: rgba(29, 30, 43, 0.8);
  background: rgba(255, 255, 255, 0.6);
  border-radius: 33px;
  position: absolute;
  top: 23px;
  left: 23px;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

type ProfileCardProps = {
  avatarSrc: string;
  avatarName: string;
  tag?: string;
  name: string;
  location: string;
  bio: string;
  userId: string;
  mode?: 'edit' | 'view';
  onAddFriendClicked?: () => void;
  addFriendDisabled: boolean;
  requestAccepted: boolean;
  role?: string;
  tooltipContent: string;
};

const defaultBio = 'Add a bio to get others know about you.';
export type RelationButtonsProps = {
  userId: string;
  onAddFriendClicked?: () => void;
  buttonStyles: {
    viewProfile?: React.CSSProperties;
    addButton?: React.CSSProperties;
  };
  buttonVisible: {
    viewProfile: boolean;
    message: boolean;
    addFriendDisabled: boolean;
  };
  tooltipContent: string;
};

export const RelationButtons = ({
  userId,
  onAddFriendClicked,
  buttonStyles,
  buttonVisible,
  tooltipContent,
}: RelationButtonsProps): JSX.Element => {
  const history = useHistory();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {buttonVisible.viewProfile && (
        <StyledButtonOutlined
          style={buttonStyles?.viewProfile}
          onClick={() => history.push(`/profile${userId ? `/${userId}` : ''}`)}
        >
          View Profile
        </StyledButtonOutlined>
      )}
      {buttonVisible.message ? (
        <Tooltip title={tooltipContent}>
          <StyledButtonFilled
            style={buttonStyles?.addButton}
            onClick={
              onAddFriendClicked
                ? onAddFriendClicked
                : () => {
                    console.log('disabled add friend');
                  }
            }
          >
            MESSAGE
          </StyledButtonFilled>
        </Tooltip>
      ) : buttonVisible.addFriendDisabled ? (
        <Tooltip title={tooltipContent}>
          <StyledButtonDisabled style={buttonStyles?.addButton}>
            ADD FRIEND
          </StyledButtonDisabled>
        </Tooltip>
      ) : (
        <Tooltip title={tooltipContent}>
          <StyledButtonFilled
            style={buttonStyles?.addButton}
            onClick={
              onAddFriendClicked
                ? onAddFriendClicked
                : () => {
                    console.log('disabled add friend');
                  }
            }
          >
            ADD FRIEND
          </StyledButtonFilled>
        </Tooltip>
      )}
    </div>
  );
};

const ProfileCard = ({
  avatarSrc,
  tooltipContent,
  avatarName,
  name,
  role,
  location,
  bio,
  userId,
  mode = 'edit',
  onAddFriendClicked,
  addFriendDisabled,
  requestAccepted,
}: ProfileCardProps): JSX.Element => {
  const history = useHistory();
  const [applicationYear, setApplicationYear] = useState('');
  const [description, setDescription] = useState('');
  const [hobbies, setHobbies] = useState<string>();
  const [isStudent, setIsStudent] = useState(false);
  const getAvatarNameByFullName = () => {
    if (avatarName.trim()) {
      return avatarName;
    }
    if (!name) return '';
    const splittedName = name.split(' ');
    if (splittedName.length === 1) return name[0];
    return `${splittedName[0][0]}${splittedName[1][0]}`;
  };
  useEffect(() => {
    async function getUserHobbies() {
      const dataProvider = await getInstance();
      const { data: result } = await dataProvider.get(
        `/usersProfiles?filter=${JSON.stringify({
          userId,
        })}`
      );
      setHobbies(
        result && result.data && result.data.length > 0
          ? result.data[0]?.hobbies || ''
          : ''
      );
    }
    if (userId) {
      getUserHobbies();
    }
  }, [userId]);

  useEffect(() => {
    async function getUserProfile(userId: string) {
      const { data } = await CR_Client.query<{
        user: {
          description?: string;
          studentInfo: {
            yearOfApplication: string;
          };
          roles: Array<{
            roleId: string;
            isPrimary: boolean;
          }>;
        };
      }>({
        query: QUERY_USER_INFO,
        variables: {
          userId,
        },
        fetchPolicy: 'no-cache',
      });
      if (data?.user) {
        const { studentInfo, roles, description } = data?.user;
        const isStudent = roles.find(role => role.roleId === 'STUDENT');
        setIsStudent(!!isStudent);
        const applicationYear =
          isStudent && studentInfo?.yearOfApplication?.split('/').length > 0
            ? studentInfo?.yearOfApplication?.split('/')[0]
            : '';
        setApplicationYear(applicationYear);
        setDescription(description || '');
      }
    }
    if (userId) {
      getUserProfile(userId);
    }
  }, [userId]);
  return (
    <Wrapper>
      <HeaderContainer>
        {role && <Role>{role}</Role>}
        <img
          className="header-bg"
          src="/img/profile/profile_bg.svg"
          alt="profile background"
        />
        <AvatarContainer>
          <Avatar
            type={AVATAR_TYPE.USER}
            src={avatarSrc}
            name={getAvatarNameByFullName()}
            style={{ width: '70px', height: '70px' }}
            size={70}
          />
        </AvatarContainer>
        {applicationYear && (
          <ApplicationYear>{applicationYear}</ApplicationYear>
        )}
      </HeaderContainer>
      <NameSection>{name}</NameSection>
      <LocationSection>
        <LocationOn /> {location}
      </LocationSection>
      {mode === 'view' && description && (
        <ShortBio
          style={{
            color: '#73747D',
          }}
        >
          {description}
        </ShortBio>
      )}
      {mode === 'edit' && description && (
        <ShortBio
          style={{
            color: description ? '#73747D' : '#FDAA02',
          }}
        >
          {description || defaultBio}
        </ShortBio>
      )}
      {mode === 'edit' && (
        <StyledButtonOutlined
          style={{
            width: 'calc(100% - 96px)',
            margin: '19px auto 0px auto',
          }}
          onClick={() => history.push(`/profile${userId ? `/${userId}` : ''}`)}
        >
          Edit My Profile
        </StyledButtonOutlined>
      )}
      {mode === 'view' && (
        <RelationButtons
          buttonVisible={{
            viewProfile: isStudent,
            message: requestAccepted,
            addFriendDisabled,
          }}
          onAddFriendClicked={onAddFriendClicked}
          userId={userId}
          tooltipContent={tooltipContent}
          buttonStyles={{
            viewProfile: {
              width: '130px',
              minWidth: 'auto',
              margin: '19px 8px 0px 17px',
            },
            addButton: {
              width: isStudent ? '134px' : '250px',
              minWidth: 'auto',
              margin: isStudent ? '19px 17px 0px 0px' : '19px auto 0px auto',
            },
          }}
        />
      )}
      {hobbies && (
        <HobbiesSection>
          <div className="title">Hobbies</div>
          <div className="hobbies">{getDisplayValue(hobbies)}</div>
        </HobbiesSection>
      )}
    </Wrapper>
  );
};

export default ProfileCard;
